/**
 * Warstwa API: ZASOBY SIECIOWE PRZYPISANE DO DZIAŁU — zakładka /moj-dzial/uprawnienia (S11, 2026-09-14).
 *
 * Polecenie właściciela: „https://mpracownik.krosno.com/moj-dzial/uprawnienia - wypisz zasoby sieciowe też przypisane
 * do działu, to ważne.”
 *
 * Trasa backendu: `GET api/my-dept/zasoby-dzialu` (polityka `PERM:ModuleMojDzial`, `MyDeptController.GetZasobyDzialu`).
 * Zakres liczy SERWER: działy odpowiedzialności zakładki Uprawnienia z kaskadą pod-jednostek (nie członkostwo).
 * `?dzial=` i `?zakladka=` dokleja centralnie `api/zakresMojegoDzialu.js` (prefiks `/my-dept/`).
 *
 * Kształt odpowiedzi:
 *   { zakres: "odpowiedzialnosc-z-kaskada",
 *     grupy: [{ departmentId, departmentName,
 *               zasoby: [{ id, nazwa, name, friendlyName, nazwaKanoniczna, opis, kind, masterDiskAddress, sharePointUrl,
 *                          linkWindows, linkMac, linkSharePoint, isAcceptNeeded, ownerName, canManage,
 *                          zespol: [{ userId, imieNazwisko, odczyt, zapis, odKiedy, odebranieZgloszone, toJa }],
 *                          liczbaZespolu, liczbaZespoluZapis, liczbaSpozaZespolu }] }] }
 *
 * Kontrakt: `attach(api)` zwraca nazwane metody doczepiane do wspólnego `apiService` (patrz attachApiModules).
 */
export function attach(api) {
    return {
        getMyDeptZasobyDzialu: () => api.get("/my-dept/zasoby-dzialu"),
    };
}
